import {brandConfig} from '../constants';
import {getCookie} from '../index';

interface TrackRegistrationParams {
  analyticsService: any;
  email: string;
  name?: string;
}

export const trackRegistration = ({email, name, analyticsService}: TrackRegistrationParams) => {
  if (brandConfig.isGx) {
    // track form submission
    (window as any).dataLayer?.push({event: 'form_submitted'});

    // track UTM campaign
    const utm_campaign = getCookie('utm_campaign');
    if (utm_campaign) {
      analyticsService.sendEvent({event_type: 'signup', code: utm_campaign});
    }

    // track in HubSpot
    (window as any)._hsq = (window as any)._hsq ?? [];
    (window as any)._hsq.push(['identify', {email, ...(name && {firstname: name})}]);
    (window as any)._hsq.push(['trackPageView']);
  }
};
